export default __webpack_public_path__ + "static/media/shareCn1.ab9bb413.jpg";